import Delta from "quill-delta";
import { QuillDeltaToHtmlConverter } from "quill-delta-to-html";
import { api as viewerApi } from "v-viewer";
import katex from "katex";
import { getHtmlString } from "./quill/quill-extend.js"

// 获取存储本地数据
export function getLocalStor(name) {
  let localObj = JSON.parse(localStorage.getItem(name));
  return localObj;
}
// 修改本地数据，可对比替换某一对象。无需全部填写
export function setLocalStor(name, data) {
  let localObj = JSON.parse(localStorage.getItem(name))
    ? JSON.parse(localStorage.getItem(name))
    : false;
  if (localObj && typeof localObj == "object" && typeof data == "object") {
    for (const key in data) {
      localObj[key] = data[key];
    }
  } else {
    localObj = data;
  }
  localStorage.setItem(name, JSON.stringify(localObj));
}
//将base64转换为文件
export function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
// 复制文本到剪贴板
export function copyToClipboard(url) {
  let copyInput = document.createElement("input");
  document.body.appendChild(copyInput);
  copyInput.value = url;
  copyInput.select();
  document.execCommand("copy");
  copyInput.remove();
}
// 获取富文本html内容
export const quillGetHTML = (queryDetal) => {
  queryDetal = JSON.parse(queryDetal);
  let i = 0;
  queryDetal.forEach((value) => {
    if (value && value.insert && value.insert.hollow) {
      if (!value.attributes) {
        value.attributes = {
          isHollow: true,
        };
      } else {
        value.attributes.isHollow = true;
      }
      value.insert = value.insert.hollow;
    } else if (value?.insert?.divider?.trim() === "") {
      value.insert = " ";
      value.attributes = {
        divider: "",
      };
    } else if (value && value.attributes?.fillIn) {
      value.insert = `${++i}`;
    }
  });
  const converterOptions = {
    customTagAttributes: (format, deltaOp) => {
      if (format.attributes?.isHollow) {
        return {
          class: "ql-hollow-insert",
        };
      } else if (format.attributes.divider === "") {
        let attributes = format.attributes;
        attributes["class"] = "ql-customLine";
        return attributes;
      } else if (format.attributes?.fillIn) {
        return {
          class: "ql-fill-in-insert",
        };
      }
      return null; // 使用默认处理方式
    },
  };

  let quillToHtml = new QuillDeltaToHtmlConverter(queryDetal, converterOptions);
  let htmlString = getHtmlString(quillToHtml);
  return htmlString;
};
/**
 * 获取编译器html内容且存在挖空功能
 * @param {*} queryDetal：富文本内容
 * 父级要绑定点击事件： addEventHtmlClick
 * @returns
 */
export const getQuillContentHollowingOut = (queryDetal, option = {}) => {
  let values = JSON.parse(queryDetal);
  values.forEach((value) => {
    if (value?.insert?.divider?.trim() === "") {
      value.insert = " ";
      value.attributes = {
        divider: "",
      };
    }
  });
  const converterOptions = {
    customTagAttributes: (format, deltaOp) => {
      if (format.insert.type == "image") {
        let attributes = format.attributes;
        if (format.attributes.style) {
          let formatInfo = JSON.parse(format.attributes.style).formatInfo;
          attributes["formatInfo"] = JSON.stringify(formatInfo).replace(
            /"/g,
            "'"
          ); // 替换双引号为单引号
          attributes["canClick"] = option?.canClick || false;
          delete attributes.style;
        }
        return attributes;
      } else if (format.attributes.divider === "") {
        let attributes = format.attributes;
        attributes["class"] = "ql-customLine";
        return attributes;
      }
      return null; // 使用默认处理方式
    },
  };
  let converter = new QuillDeltaToHtmlConverter(values, converterOptions);
  converter.renderCustomWith((customOp, contextOp) => {
    if (customOp.insert.type === "hollow") {
      let val = customOp.insert.value;
      if (!val) return;
      // 如果是文本
      let defaultColor = "";
      let newstyle = [];
      for (let key in customOp.attributes) {
        if (
          customOp.attributes.hasOwnProperty(key) &&
          key !== "isHollow" &&
          key !== "background"
        ) {
          newstyle.push(key + ":" + customOp.attributes[key] + "");
          if (key == "color") {
            defaultColor = customOp.attributes[key];
          }
        }
      }
      if (typeof val == "string") {
        return `<span isHollow='true' defaultColor='${defaultColor}' style='${newstyle.join(
          "; "
        )}'>${val}</span>`;
      }
    } else if (customOp.insert.type === "audio") {
      return (
        '<audio class="ql-audio" controls="controls" preload="auto" controlsList="nodownload" src="' +
        customOp.insert.value +
        '"><source src="' +
        customOp.insert.value +
        '"></audio>'
      ); // 返回自定义的HTML字符串
    } else if (customOp.insert && customOp.insert.type === "customVideo") {
      if (customOp.insert.value.startsWith("https://vod.keymemox.com")) {
        return `<video class="ql-video" src="${customOp.insert.value}" controls><source src="${customOp.insert.value}" type="video/mp4">您的浏览器不支持 Video 标签。</video>`; // 返回自定义的HTML字符串
      } else {
        return `<iframe class="ql-video" controls preload="auto" controlsList="nodownload nofullscreen noplaybackrate" src="${customOp.insert.value}"> <source src="${customOp.insert.value}" type="video/mp4">Your browser does not support the video tag.</iframe>`; // 返回自定义的HTML字符串
      }
    } else if (customOp.insert && customOp.insert.type === "table") {
      return renderTableHtml(customOp.insert.value); // 返回自定义的HTML字符串
    }
  });
  converter.afterRender((groupType, htmlString) => {
    // 创建DOM解析器
    const parser = new DOMParser();
    // 解析HTML字符串
    const doc = parser.parseFromString(htmlString, "text/html");
    const spans = doc.querySelectorAll("span");
    spans.forEach((span) => {
      // 如果是公式就进行处理
      if (span.classList.contains("ql-formula")) {
        let katexHtml = katex.renderToString(span.innerText, {
          throwOnError: false,
        });
        const regex = /<span class="katex-mathml">([\s\S]*?)<\/span>/;
        const match = regex.exec(katexHtml);
        let targetHtmlString = match ? match[0] : "";
        span.classList.add("ql-formula-katex");
        span.innerHTML = targetHtmlString;
      } else if (span.attributes && span.attributes.isHollow) {
        span.style.cursor = "pointer"; // 鼠标指针
        span.classList.add("hollowingUut-class"); // 添加挖空显示的样式
      }
    });
    return doc.body.innerHTML;
  });
  let htmlString = converter.convert();
  return htmlString;
};
// 给父元素添加一个点击事件
export function addEventHtmlClick(event, hideImage = false) {
  let clickedElement = event.target;
  if (clickedElement.tagName === "IMG") {
    if (hideImage) return;
    event.stopPropagation();
    let src = clickedElement.src;
    const $viewer = viewerApi({
      options: {
        toolbar: true,
        initialViewIndex: 0,
      },
      images: [src],
    });
  } else {
    let isHollowDom = false;
    while (clickedElement) {
      if (
        clickedElement.hasAttribute &&
        clickedElement.hasAttribute("isHollow")
      ) {
        isHollowDom = true;
        break;
      }
      clickedElement = clickedElement.parentElement;
    }
    if (isHollowDom) {
      event.stopPropagation();
      if (clickedElement.classList.contains("hollowingUut-class")) {
        clickedElement.classList.remove("hollowingUut-class");
        let color = clickedElement.getAttribute("defaultColor");
        clickedElement.style.color = color;
      } else {
        clickedElement.classList.add("hollowingUut-class");
      }
    }
  }
}
// 获取富文本html内容-将文本跟图片分离
export const quillGetHTMLAndImage = (queryDetal, option = {}) => {
  if (!queryDetal) {
    queryDetal = [{ insert: "" }];
  }
  let values = null;
  try {
    values = new Delta(JSON.parse(queryDetal));
  } catch (error) {
    values = new Delta(JSON.parse(JSON.stringify(queryDetal)));
  }
  let valueOps = [];
  let images = [];
  values.ops.forEach((value, index) => {
    if (typeof value?.insert?.image === "string") {
      images.push({
        src: value.insert.image,
        formatInfo: value.attributes?.style
          ? JSON.parse(value.attributes.style).formatInfo
          : null,
        canClick: option?.canClick || false,
      });
    } else if (typeof value?.insert?.hollow === "string") {
      if (!value.attributes) {
        value.attributes = {
          isHollow: "true",
          background: "#D3F8B7",
        };
      } else {
        value.attributes.isHollow = "true";
        value.attributes.background = "#D3F8B7";
      }
      value.insert = value.insert.hollow;
      valueOps.push(value);
    } else if (value?.insert?.divider?.trim() === "") {
      value.insert = " ";
      value.attributes = {
        divider: "",
      };
      valueOps.push(value);
    } else {
      if (index === values.ops.length - 1) {
        value.insert = value.insert.trimEnd();
      }
      valueOps.push(value);
    }
  });
  const converterOptions = {
    customTagAttributes: (format, deltaOp) => {
      if (format.insert.type == "image") {
        let attributes = format.attributes;
        if (format.attributes?.style && isJSON(format.attributes.style)) {
          let formatInfo = JSON.parse(format.attributes.style).formatInfo;
          attributes["formatInfo"] = JSON.stringify(formatInfo).replace(
            /"/g,
            "'"
          ); // 替换双引号为单引号
          attributes["canClick"] = option?.canClick || false;
          delete attributes.style;
        }
        return attributes;
      } else if (format.attributes.divider === "") {
        let attributes = format.attributes;
        attributes["class"] = "ql-customLine";
        return attributes;
      }
      return null; // 使用默认处理方式
    },
  };
  let quillToHtml = new QuillDeltaToHtmlConverter(valueOps, converterOptions);

  let htmlString = getHtmlString(quillToHtml);
  return {
    html: htmlString,
    images: images,
  };
};

// 防抖
export const debounce = (func, delay) => {
  let timer;
  let immediate = true; // 用于标记是否立即执行
  const debounced = function () {
    const context = this;
    const args = arguments;
    if (immediate) {
      func.apply(context, args);
      immediate = false;
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      immediate = true;
    }, delay);
  };
  // 立即执行
  debounced();
  return debounced;
};
export function throttle(func, wait) {
  let timeout = null;
  let lastArgs = null;
  let lastThis = null;
  let lastCallTime = 0;

  return function (...args) {
    const now = Date.now();
    const remainingTime = wait - (now - lastCallTime);

    lastArgs = args;
    lastThis = this;

    if (remainingTime <= 0) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      lastCallTime = now;
      func.apply(lastThis, lastArgs);
    } else if (!timeout) {
      timeout = setTimeout(() => {
        lastCallTime = Date.now();
        timeout = null;
        func.apply(lastThis, lastArgs);
      }, remainingTime);
    }
  };
}
//数字格式化
export function numberToStr(num) {
  if (num >= 100000000) {
    return 999 + "w+";
  } else if (num >= 10000) {
    return Math.floor((num / 10000) * 10) / 10 + "w";
  } else if (num >= 1000) {
    return Math.floor((num / 1000) * 10) / 10 + "k";
  } else {
    return num.toString();
  }
}
// 生成唯一key
export function getRandomCode(length) {
  if (length > 0) {
    var data = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
      "a",
      "b",
      "c",
      "d",
      "e",
      "f",
      "g",
      "h",
      "i",
      "j",
      "k",
      "l",
      "m",
      "n",
      "o",
      "p",
      "q",
      "r",
      "s",
      "t",
      "u",
      "v",
      "w",
      "x",
      "y",
      "z",
    ];
    var nums = "";
    for (var i = 0; i < length; i++) {
      let aa = Math.random() * 61 + "";
      var r = parseInt(aa);
      nums += data[r];
    }
    return nums;
  } else {
    return false;
  }
}
//文件类型图标
export const fileImgList = {
  c0: {
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/notebook.png", //内容图标
    name: "知识闪卡",
  },
  c2: {
    name: "图集相册",
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/photo.png",
  },
  c4: {
    name: "文档遮罩",
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/word.png",
  },
  c5: {
    name: "多维闪卡",
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/multiDimCard.png",
  },
  c6: {
    name: "习题集",
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/topicCase.png",
  },
  c7: {
    name: "音频合集",
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/audioCard.png",
  },
  c8: {
    name: "视频合集",
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/videoCard.png",
  },
  c9: {
    name: "文章专栏",
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/article.png",
  },
  f0: {
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/folder.png",
    name: "文件夹",
  },
  f1: {
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/mindMap.png",
    name: "思维导图",
  },
  c11: {
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/mindMap.png",
    name: "思维导图",
  },
  c12: {
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/directory.png",
    name: "目录大纲",
  },
  c13: {
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/compositeCard.png",
    name: "综合学习集",
  },
  f3: {
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/directory.png",
    name: "目录大纲",
  },
  f4: {
    img: "https://image.keymemox.com/images/cassette/case_img_1_5/block.png",
    name: "便签学习集",
  },
};
// 根据不同学习集类型前往官网的不同管理页
export const keyFile = {
  c0: {
    title: "知识闪卡",
  },
  c2: {
    title: "图集相册",
  },
  c4: {
    title: "文档遮罩",
  },
  c5: {
    title: "多维闪卡",
  },
  c6: {
    title: "习题集",
  },
  c7: {
    title: "音频合集",
  },
  c8: {
    title: "视频合集",
  },
  c9: {
    title: "文章专栏",
  },
  c11: {
    title: "思维导图",
    type: "card",
  },
  c12: {
    title: "目录大纲",
  },
  f0: {
    title: "文件夹",
  },
};
//处理思维导图数据list->tree
export const preProcessMindMapData = (list) => {
  let mindMapData = JSON.parse(JSON.stringify(list));
  let mapType = {
    c0: { name: "卡盒", id: "c_", type: "card" },
    f1: { name: "单项导图", id: "f_", type: "file" },
    f0: { name: "文件夹", id: "f_", type: "file" },
  };
  let nlist = [];
  mindMapData.forEach((val) => {
    let pid = val.parentId || val.rootId;
    // 排除不符合的类型
    if (!val.fileType in mapType) return;
    let obj = {
      id: mapType[val.fileType].id + val.id,
      label: val.title || "",
      keyname: mapType[val.fileType].type,
      parentId: "f_" + pid,
    };
    // 双面卡盒需要添加额外数据
    if (obj.keyname == "card") {
      obj["labelTwo"] = "学习卡" + val.cardNum;
    }
    nlist.push(obj);
  });
  const map = {};
  const tree = [];
  // 第一步：遍历 list 并填充 map
  nlist.forEach((item) => {
    if (!item.children) {
      item.children = [];
    }
    map[item.id] = item;
  });
  // 第二步：构建树状结构
  nlist.forEach((item) => {
    if (item.parentId && map[item.parentId]) {
      map[item.parentId].children.push(item);
    } else {
      tree.push(item);
    }
  });
  return tree;
};
// 判断是否为苹果设备
export function isAppleDevice() {
  var userAgent = navigator.userAgent.toLowerCase();
  return /iphone|ipad|ipod|macintosh|mac os x/i.test(userAgent);
}

// 创作投稿分类
export const cascaderOptions = [
  {
    value: "考研",
    label: "考研",
    children: [
      {
        value: "政治",
        label: "政治",
      },
      {
        value: "英语",
        label: "英语",
      },
      {
        value: "数学",
        label: "数学",
      },
      {
        value: "专业课",
        label: "专业课",
      },
      {
        value: "其他",
        label: "其他",
      },
    ],
  },
  {
    value: "考公",
    label: "考公",
    children: [
      {
        value: "公务员",
        label: "公务员",
      },
      {
        value: "事业编",
        label: "事业编",
      },
      {
        value: "军队文职",
        label: "军队文职",
      },
      {
        value: "其他",
        label: "其他",
      },
    ],
  },
  {
    value: "幼儿教育",
    label: "幼儿教育",
    children: [
      {
        value: "认知发展",
        label: "认知发展",
      },
      {
        value: "语言启蒙",
        label: "语言启蒙",
      },
      {
        value: "社交与情感",
        label: "社交与情感",
      },
    ],
  },
  {
    value: "K12教育",
    label: "K12教育",
    children: [
      {
        value: "语文",
        label: "语文",
      },
      {
        value: "数学",
        label: "数学",
      },
      {
        value: "英语",
        label: "英语",
      },
      {
        value: "科学（物理、化学、生物）",
        label: "科学（物理、化学、生物）",
      },
      {
        value: "社会科学（历史、地理、政治）",
        label: "社会科学（历史、地理、政治）",
      },
    ],
  },
  {
    value: "高等教育",
    label: "高等教育",
    children: [
      {
        value: "工程与技术",
        label: "工程与技术",
      },
      {
        value: "自然科学",
        label: "自然科学",
      },
      {
        value: "医学",
        label: "医学",
      },
      {
        value: "商业与管理",
        label: "商业与管理",
      },
      {
        value: "人文与社会科学",
        label: "人文与社会科学",
      },
    ],
  },
  {
    value: "职业教育",
    label: "职业教育",
    children: [
      {
        value: "职业技能认证",
        label: "职业技能认证",
      },
      {
        value: "行业知识",
        label: "行业知识",
      },
      {
        value: "职场发展",
        label: "职场发展",
      },
    ],
  },
  {
    value: "终身学习",
    label: "终身学习",
    children: [
      {
        value: "个人发展",
        label: "个人发展",
      },
      {
        value: "兴趣爱好",
        label: "兴趣爱好",
      },
      {
        value: "生活技能",
        label: "生活技能",
      },
    ],
  },
  {
    value: "语言学习",
    label: "语言学习",
    children: [
      {
        value: "英语",
        label: "英语",
      },
      {
        value: "小语种",
        label: "小语种",
      },
      {
        value: "语言考试",
        label: "语言考试",
      },
    ],
  },
  {
    value: "兴趣爱好",
    label: "兴趣爱好",
    children: [
      {
        value: "艺术创作",
        label: "艺术创作",
      },
      {
        value: "体育运动",
        label: "体育运动",
      },
      {
        value: "游戏娱乐",
        label: "游戏娱乐",
      },
      {
        value: "手工艺",
        label: "手工艺",
      },
    ],
  },
  {
    value: "健康与生活",
    label: "健康与生活",
    children: [
      {
        value: "健康饮食",
        label: "健康饮食",
      },
      {
        value: "身体锻炼",
        label: "身体锻炼",
      },
      {
        value: "心理健康",
        label: "心理健康",
      },
      {
        value: "老年生活",
        label: "老年生活",
      },
    ],
  },
  {
    value: "科普知识",
    label: "科普知识",
    children: [
      {
        value: "科学探索",
        label: "科学探索",
      },
      {
        value: "环境保护",
        label: "环境保护",
      },
      {
        value: "安全教育",
        label: "安全教育",
      },
    ],
  },
  {
    value: "文化艺术",
    label: "文化艺术",
    children: [
      {
        value: "文学作品",
        label: "文学作品",
      },
      {
        value: "艺术欣赏",
        label: "艺术欣赏",
      },
      {
        value: "音乐与舞蹈",
        label: "音乐与舞蹈",
      },
      {
        value: "戏剧与电影",
        label: "戏剧与电影",
      },
    ],
  },
  {
    value: "其他",
    label: "其他",
    children: [
      {
        value: "其他",
        label: "其他",
      },
    ],
  },
];

// 判断当前设备是否为移动设备
export function detectDeviceType() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检测是否为移动设备
  const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
  if (isMobile) {
    return true;
  } else {
    return false;
  }
}
// 判断是否为微信浏览器
export function isWeixin() {
  let ua = navigator.userAgent.toLowerCase();
  return ua.indexOf("micromessenger") !== -1;
}
// 秒数转时分秒
export function formatSeconds(value) {
  let second = parseInt(value);
  let minute = 0;
  let hour = 0;
  if (second >= 60) {
    minute = parseInt(second / 60);
    second = parseInt(second % 60);
  }
  if (minute >= 60) {
    hour = parseInt(minute / 60);
    minute = parseInt(minute % 60);
  }
  let str = "";
  if (hour > 0) {
    str += hour + "时";
  }
  if (minute > 0) {
    str += minute + "分";
  }
  str += second + "秒";
  return str;
}
// 秒数转换为时间戳00:00:00
export function secondToTime(second) {
  let minute = parseInt(second / 60);
  let hour = parseInt(minute / 60);
  minute = parseInt(minute % 60);
  second = parseInt(second % 60);
  let str = "";
  if (hour > 0) {
    str += hour + ":";
  }
  if (minute < 10) {
    str += "0" + minute + ":";
  } else {
    str += minute + ":";
  }
  if (second < 10) {
    str += "0" + second;
  } else {
    str += second;
  }
  return str;
}
// 日期字符串转换为时间差描述
export function timeSince(dateStr) {
  const isoDateStr = dateStr.replace(" ", "T");
  // 解析输入的时间字符串
  const givenTime = new Date(isoDateStr);
  // 获取当前时间
  const now = new Date();
  // 计算时间差
  const timeDiff = now - givenTime;
  // 获取今天的开始时间
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  // 获取昨天的开始时间
  const yesterdayStart = new Date(todayStart.getTime() - 24 * 60 * 60 * 1000);
  // 判断时间差并返回相应的描述
  if (timeDiff < 60 * 1000) {
    return "刚刚";
  } else if (timeDiff < 3600 * 1000) {
    // 1小时 = 3600秒
    const minutes = Math.floor(timeDiff / (60 * 1000));
    return `${minutes}分钟前`;
  } else if (givenTime >= todayStart) {
    return `今天 ${givenTime.toTimeString().slice(0, 5)}`;
  } else if (givenTime >= yesterdayStart) {
    return `昨天 ${givenTime.toTimeString().slice(0, 5)}`;
  } else {
    const yearDiff = now.getFullYear() - givenTime.getFullYear();
    if (yearDiff > 0) {
      return `${givenTime.getFullYear()}年${
        givenTime.getMonth() + 1
      }月${givenTime.getDate()} ${givenTime.toTimeString().slice(0, 5)}`;
    } else {
      return `${givenTime.getMonth() + 1}月${givenTime.getDate()} ${givenTime
        .toTimeString()
        .slice(0, 5)}`;
    }
  }
}
// 重命名文件名称
export function renameFile(originalFile, changeName = false) {
  let fileName = originalFile.name;
  // 提取文件扩展名
  const extension = fileName.substring(fileName.lastIndexOf("."));
  // 移除文件名中的不规则字符，仅保留字母和数字
  let baseName = fileName
    .substring(0, fileName.lastIndexOf("."))
    .replace(/[^\u4e00-\u9fa5a-zA-Z0-9“”]/g, "");
  if (changeName) {
    baseName += generateUUID();
  }
  let cleanedName = baseName + extension;
  const renamedFile = new File([originalFile], cleanedName, {
    type: originalFile.type,
    lastModified: originalFile.lastModified,
  });
  return renamedFile;
}
